import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import PromotionForm from './PromotionForm';

const PromotionActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const PromotionCreate = (props: any) => {
  return (
    <Create actions={<PromotionActions {...props} />} {...props}>
      <PromotionForm />
    </Create>
  );
};

export default PromotionCreate;
